import { Serializable } from "../core";
import { Address, Order } from "./index";

export class User implements Serializable<User> {
  firstName!: string;
  sureName!: string;
  phoneNumber!: string;
  email?: string;
  addresses!: Address[];
  orders!: Order[];

  deserialize(json: any): User {
    this.firstName = json.first_name;
    this.sureName = json.sur_name;
    this.phoneNumber = json.phone_number;
    this.email = json.email === null ? "" : json.email;
    this.addresses = json.addresses.map((json: any) =>
      new Address().deserialize(json)
    );
    this.orders = json.orders.map((json: any) => new Order().deserialize(json));
    return this;
  }
}
